import React, { useState } from "react";

const VoucherCode = ({
  onApply = async () => {},
  onRemove = () => {},
  appliedCode = "",
  variant = "receipt",
}) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isApplied = Boolean(appliedCode);
  const isReceipt = variant === "receipt";

  const stopSidebarToggle = (e) => {
    e.stopPropagation();
  };

  const handleApply = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const trimmed = code.trim();
    if (!trimmed) {
      setError("Please enter a voucher code");
      return;
    }
    if (isApplied) return;

    setLoading(true);
    setError("");
    try {
      await onApply(trimmed);
      setCode("");
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.nonFieldErrors?.[0] ||
        err?.response?.data?.code?.[0] ||
        err?.message ||
        "Invalid voucher code";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setCode("");
    setError("");
    onRemove();
  };

  const inputField = (
    <div className="checkout__voucher-field">
      <input
        type="text"
        placeholder="Voucher code"
        value={isApplied ? appliedCode : code}
        onChange={(e) => setCode(e.target.value)}
        disabled={loading || isApplied}
        className={
          "registration-form__input checkout__voucher-field-input" +
          (error ? " registration-form__input--error" : "")
        }
        autoComplete="off"
      />
      {!isApplied ? (
        <button
          type="submit"
          className={
            "checkout__voucher-field-action" +
            (loading || !code.trim() ? " checkout__voucher-field-action--disabled" : "")
          }
          disabled={loading || !code.trim()}
        >
          {loading ? "Applying…" : "Apply"}
        </button>
      ) : (
        <button
          type="button"
          className="checkout__voucher-field-action"
          onClick={handleRemove}
        >
          Remove
        </button>
      )}
    </div>
  );

  if (isReceipt) {
    return (
      <div
        className="checkout__voucher checkout__voucher--receipt"
        onClick={stopSidebarToggle}
      >
        <form className="checkout__voucher-form" onSubmit={handleApply}>
          {inputField}
          {error && (
            <p className="error-message checkout__voucher-message">{error}</p>
          )}
        </form>
      </div>
    );
  }

  return (
    <div className="checkout__voucher checkout__voucher--inline">
      <label htmlFor="voucher-code" className="checkout__voucher-label">
        Voucher Code
      </label>
      <form className="checkout__voucher-form" onSubmit={handleApply}>
        {inputField}
      </form>
      {error && (
        <p className="error-message checkout__voucher-message">{error}</p>
      )}
      {isApplied && (
        <p className="success-message checkout__voucher-message">
          Voucher applied successfully
        </p>
      )}
    </div>
  );
};

export default VoucherCode;
